// src/actions/educationActions.js
import api from '../api/axios';
import {
  FETCH_EDUCATION_REQUEST,
  FETCH_EDUCATION_SUCCESS,
  FETCH_EDUCATION_FAILURE,

  CREATE_EDUCATION_REQUEST,
  CREATE_EDUCATION_SUCCESS,
  CREATE_EDUCATION_FAIL,

  DELETE_EDUCATION_REQUEST,
  DELETE_EDUCATION_SUCCESS,
  DELETE_EDUCATION_FAIL,

  UPDATE_EDUCATION_REQUEST,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_EDUCATION_FAIL,
} from '../constants/educationConstants';

export const fetchEducation = () => async (dispatch) => {
  dispatch({ type: FETCH_EDUCATION_REQUEST });

  try {
    const { data } = await api.get('/education/my-education/');

    dispatch({
      type: FETCH_EDUCATION_SUCCESS,
      payload: Array.isArray(data) ? data : (data.results || [])
    });

  } catch (error) {
    dispatch({
      type: FETCH_EDUCATION_FAILURE,
      payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    });
  }
};

export const createEducation = (
  schoolName,
  city,
  startDate,
  endDate,
  description = []
) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EDUCATION_REQUEST });

    await api.post('/education/my-education/create/', {
      school_name: schoolName,
      city,
      start_date: startDate,
      end_date: endDate,
      description: description,
    });

    dispatch({ type: CREATE_EDUCATION_SUCCESS });
    dispatch(fetchEducation());
  } catch (error) {
    dispatch({
      type: CREATE_EDUCATION_FAIL,
      payload: error.response?.data?.non_field_errors?.[0] || error.message
    });
  }
};

export const deleteEducation = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EDUCATION_REQUEST });

    await api.delete(`/education/my-education/delete/${id}/`);

    dispatch({ type: DELETE_EDUCATION_SUCCESS });
    dispatch(fetchEducation());
  } catch (error) {
    dispatch({
      type: DELETE_EDUCATION_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const updateEducation = (education) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EDUCATION_REQUEST });

    const { data } = await api.put(
      `/education/my-education/update/${education.id}/`,
      education
    );

    dispatch({
      type: UPDATE_EDUCATION_SUCCESS,
      payload: data
    });

    dispatch(fetchEducation());
  } catch (error) {
    dispatch({
      type: UPDATE_EDUCATION_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};